export const DEFAULT_PAGE_LIMIT = 15;
export const RETAIL_PRICE = 'Retail Price';
